import React from 'react';
import { I18nextProvider } from 'react-i18next'; // Import useTranslation hook
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';
import Navbar from './Common/Navbar/Navbar';
import Footer from './Common/footer/Footer';
import SinglePage from './SinglePage/SinglePage';
import About from './components/About/About';
import BlogSingle from './components/Blog/blog-single-page/BlogSingle';
import Contact from './components/Contact/Contact.js';
import Gallery from './components/Gallery/Gallery.js';
import Home from './components/pages/Home';
import i18n from './i18n/translation.js';


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <>
        <Router>
          <Navbar />
          <Routes>
            <Route path="/" exact element={<Home />} />
            <Route path="/about" exact element={<About />} />
            <Route path="/gallery" exact element={<Gallery />} />
            <Route path="/singlepage/:id" element={<SinglePage />} />
            <Route path="/blogsingle/:id" element={<BlogSingle />} />
            <Route path="/contact" element={<Contact />} />
            {/* <Route path="/rate" element={<Rate />} /> */}
          </Routes>
          <Footer />
        </Router>
      </>
    </I18nextProvider>
  );
}

export default App;
